import { useEffect } from "react";
import DataTable from "react-data-table-component";
import { useSolicitudesCurso } from "../solicitudes-en-curso/useSolicitudesCurso";
import { UseSolicitudesHistoriales } from "../listado-historial/UseSolicitudesHistoriales";
import { ModalBodylHistorial } from "./modalHistorial/modalHistorial";
import { useHistorialSolicitudes } from "./useHistorialSolicitudes";
import { ModalContractuales } from "../modalForm/modalForm";
import { customStyles, paginationComponentOptions } from "../../utils/Constants";
import { Button } from "../../components/formComponents/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

export const HistorialSolicitudes = () => {
  const { visible, hideModal, idSolicitud, arrColumnas } = useSolicitudesCurso();
  const { historialListado, traerListadoHistorial } = UseSolicitudesHistoriales();
  const { descargarHistorialExcel } = useHistorialSolicitudes();

  useEffect(() => {
    traerListadoHistorial();
  }, []);

  return (
    <>
      <ModalContractuales
        tamanio="xl"
        show={visible}
        data={{
          titulo: "Historial de solicitud",
          component: <ModalBodylHistorial id={idSolicitud} />,
        }}
        hideModal={hideModal}
      />
      <div className="d-flex align-items-center flex-column">
        <div className="col col-12 col-lg-10 px-4">
          <DataTable
            data={historialListado}
            columns={arrColumnas}
            customStyles={customStyles}
            dense
            pagination
            noDataComponent="No se encontraron registros"
            paginationComponentOptions={paginationComponentOptions}
          />
          <div className="mt-1">
            <Button
              label={
                <div>
                  <label className="cursor-pointer">Descargar historial</label>
                  <FontAwesomeIcon size="lg" className="ps-3" icon={faDownload} />
                </div>
              }
              clases="btnCopec ms-0 px-4 cursor-pointer"
              ejecutar={descargarHistorialExcel}
            />
          </div>
        </div>
      </div>
    </>
  );
};
